import { Container } from "react-bootstrap";
import "./SkipLinksCard.css";

const SkipLinksCard = (props) => {
  
  const handleClick = (e) => {
    props.onSectionSelect(e.target.id);
    let sec_top = document.getElementById(
      e.target.id.replace('-link', "")
    ).offsetTop - 150
    window.scrollTo({
      left: 0, 
      top: sec_top,
      behavior: 'auto'
    });
  }

  return(
    <div className="skip-links-card-wrapper">
      <Container fluid className="skip-links-card">
        <div className="skip-links-card-title">
          <span>Skip Links</span>
        </div>
        <div className="skip-links">
          {props.skip_links.map(
            (val, i) => 
            <div 
              id={"section"+String(i+1)+"-link"} 
              key={i} 
              onClick={handleClick} 
              className={"skip-link " + ("section"+String(i+1)+"-link" === props.active_section ? 'active' : '')}>
              {val}
            </div>
          )}
        </div>
      </Container>
    </div>
  )
}

export default SkipLinksCard;
